/**
 * @desc 新增领用详情
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.AddDeliveryDetail,
): Promise<defs.StandardReturn<string>> {
  return defHttp.post({
    url: '/web/labour/addDeliveryDetail',
    data,
  });
}

export function mock(
  data: defs.AddDeliveryDetail,
): Promise<defs.StandardReturn<string>> {
  return defHttp.post({
    url: '/mock/web/labour/addDeliveryDetail',
    data,
  });
}
